var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53866 13.9999H10.4613C12.935 13.9999 13.378 13.0339 13.5072 11.8579L13.9687 7.0579C14.1349 5.5939 13.7041 4.3999 11.0767 4.3999H4.92333C2.29585 4.3999 1.86512 5.5939 2.03126 7.0579L2.49276 11.8579C2.62198 13.0339 3.06502 13.9999 5.53866 13.9999Z",
    stroke: "#0F172B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.0013,
    cy: 9.33333,
    r: 1.33333,
    stroke: "#0F172B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48828 8.88738C11.0225 8.71987 12.5283 8.19647 13.8738 7.33325",
    stroke: "#0F172B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54174 8.88738C5.00748 8.71987 3.50172 8.19647 2.15625 7.33325",
    stroke: "#0F172B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53906 4.4V3.92C5.53906 2.858 5.53906 2 7.50813 2H8.49267C10.4617 2 10.4617 2.858 10.4617 3.92V4.4",
    stroke: "#0F172B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.3386db7b31f3730808290a06f71802f8.svg";
export { ForwardRef as ReactComponent };